<template>
    <div class="modal-container-cont">
        <div class="modal-container">
            <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('cupom_fiscal') }}</h2>
                </div>
            </div>
            <div class="message_pager" :class="{ 'emailFieldVisible': emailFieldVisible }"
                v-if="printData.saleData.urlPager">
                <p>{{ getString('msg_pager') }} <br><br> {{ getString('msg_qrcode') }} </p>
                <img :src="printData.saleData.qrCodePager" />
            </div>
            <div class="options-buttons"
                :class="{ 'has-pager': !!printData.saleData.urlPager, 'emailFieldVisible': emailFieldVisible }">
                <template v-if="waitingPrint">
                    <div class="message-printer-waiting">
                        <p v-html="getString('aguardando_impressao_do_cupom')"></p>
                        <p class="small-text">{{ getString('nao_puxe_o_papel_da_impressora') }}</p>
                    </div>
                </template>
                <template v-else>
                    <DefaultButton v-if="!hidePrintButton" :text="getString('imprimir')" @defaultBtnClick="printCoupons(false, false)"
                    :disabled="!controlsEnabled"></DefaultButton>
                <DefaultButton v-if="sendingCupEmail" :text="getString('enviar_por_e_mail')"
                    @defaultBtnClick="showEmailField()" :disabled="!controlsEnabled"></DefaultButton>
                <DefaultButton :text="printQrCodeCatraca(printData) ? getString('qr_code_catraca') : getString('nao_preciso_do_cupom')" v-if="!sendingCupEmail || allowNotPrint"
                    @defaultBtnClick="printCoupons(true, false)" :disabled="!controlsEnabled"></DefaultButton>
                </template>
            </div>

            <div class="form" v-show="emailFieldVisible">
                <div class="config-item">
                    <div class="label-container">
                        <label for="email">{{ getString('e_mail') }}</label>
                    </div>
                    <div id="email" class="div-input-android" ref="emailDiv"></div>
                </div>

                <AndroidKeyboard id="android-keyboard" v-if="emailFieldVisible" :inputElement="inputElement"
                    :layout="layout">
                </AndroidKeyboard>

                <DefaultButton class="confirm-button" :text="getString('confirmar')" :green="true"
                    @defaultBtnClick="sendByEmail"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import DefaultButton from '@/components/DefaultButton'
import Util from '@/assets/libs/util'
import PrinterController from '@/assets/controllers/PrinterController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'

export default {
    name: 'PrintModal',
    components: {
        DefaultButton,
        AndroidKeyboard
        // 'vue-touch-keyboard': VueTouchKeyboard.component
    },
    props: ['printData'],
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.EMAIL,
            visible: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            sendingCupEmail: Util.getLocalConfigs('sendingCupEmail'),
            allowNotPrint: Util.getLocalConfigs('allowNotPrint'),
            input: null,
            rawEmail: null,
            controlsEnabled: true,
            emailFieldVisible: false,
            hidePrintButton: false,
            waitingPrint: false
        }
    },
    mounted () {
        this.inputElement = this.$refs.emailDiv
        this.hidePrintButton = this.allowNotPrint && Util.getLocalConfigs('hidePrintButton')
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        sanitizeEmail: function () {
            this.rawEmail = this.rawEmail.replace(/[^a-zA-Z0-9.@_-]+/g, '')
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        closeModal: function () {
            this.$emit('closePrintModal')
        },
        sendByEmail: function () {
            this.rawEmail = this.$refs.emailDiv.innerText
            let result = this.validateEmail()
            if (result.isValid) {
                this.printCoupons(true, true)
            } else {
                Util.showInfoModal(result.message)
            }
        },
        printQrCodeCatraca: function (printData) {
            return printData && printData.saleData && printData.saleData.qrCodeCat && printData.saleData.qrCodeCat !== ''
        },
        validateEmail: function () {
            const EMPTY_FIELD_MESSAGE = this.getString('preencha_e_mail_corretamente')
            const INVALID_EMAIL_MESSAGE = this.getString('e_mail_digitado_nao_e_valido')

            let result = {
                isValid: true,
                message: ''
            }

            if (this.rawEmail == null) {
                result.isValid = false
                result.message = EMPTY_FIELD_MESSAGE
                return result
            }

            let email = this.rawEmail.trim()

            if (email.length === 0) {
                result.isValid = false
                result.message = EMPTY_FIELD_MESSAGE
                return result
            }

            let emailRegex = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)
            let validEmail = emailRegex.test(email)

            if (!validEmail) {
                result.isValid = false
                result.message = INVALID_EMAIL_MESSAGE
                return result
            }

            return result
        },
        printCoupons: async function (userChooseNotPrint, sendByEmail) {
            if (this.controlsEnabled) {
                this.disableControls()
                if (!sendByEmail) {
                    this.waitingPrint = true
                }
                let result = await PrinterController.printCoupons(this.printData, userChooseNotPrint, sendByEmail, this.rawEmail, this.$router)
                if (result) {
                    this.enableControls()
                    this.closeModal()
                }
                this.waitingPrint = false
            }
        },
        disableControls: function () {
            this.controlsEnabled = false
        },
        enableControls: function () {
            this.controlsEnabled = true
        },
        showEmailField: function () {
            this.emailFieldVisible = true
        },
        accept: function (text) {
            this.hide()
            this.sendByEmail()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container-cont {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 3;
}

.modal-container {
    position: absolute;
    pointer-events: auto;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    transform: translate(0%, -50%);
    height: max-content;

    .modal-form-container {
        position: relative;
        overflow: hidden auto;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 40px;
            }
        }
    }

    .message_pager {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row;

        img {
            height: 380px;
            width: 380px;
        }

        p {
            font-size: 32px;
            padding: 10px 20px;
        }
    }

    .options-buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        height: 200px;
        padding: 20px;

        .button-default {
            margin: 25px 0 25px 0;
        }

        &.has-pager {
            flex-direction: row;
            height: max-content;
            justify-content: space-evenly;
            margin: 25px 0 0 0;
            .button-default {
                margin: 0 0 50px 0;
            }
        }
        .message-printer-waiting {
            font-size: 35px;
            padding: 10px 20px;
            text-align: center;
            .small-text {
                margin-top: 35px;
                color: red;
                font-size: 25px;
                text-align: center;
            }
        }
    }

    .form {
        margin: 0px 60px 0px 60px;
        min-height: 185px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .config-item {
            display: grid;
            grid-template-columns: 20% 80%;
            position: relative;
            // margin-bottom: 20px;

            label {
                font-size: 40px;
                position: relative;
                display: inline-block;
                top: 50%;
                transform: translate(0, -50%);
                margin: 0;
            }

            .div-input-android {
                position: relative;
                // margin: 30px;
                // display: block;
                display: flex;
                align-items: center;
                font-size: 35px;
                height: 65px;
                background-color: white;
                color: black;
                border: 2px solid black;
                border-radius: 20px;
                padding: 0 20px;
            }

            // input {
            //     vertical-align: middle;
            //     font-size: 2rem !important;
            //     padding: 5px 15px;
            //     border: 2px solid @primary-color;
            //     outline: none;
            //     &[type=text]{
            //         color: black;
            //     }
            //     &[type=color]{
            //         border: none;
            //         height: 100px;
            //         width: 100%;
            //         box-sizing: inherit;
            //         appearance: initial;
            //         padding: 0;
            //     }
            // }
            // .disabled-input {
            //     pointer-events: none;
            //     background: rgba(0, 0, 0, 0.1);
            //     border: 2px solid lightgray;
            //     color: gray !important;
            // }
        }

        .confirm-button {
            width: 100%;
            // margin: auto;
        }

        #android-keyboard {
            // margin: 0 30px 60px 30px;
            margin: 30px 0;
        }
    }

    .balance-information {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 60px;
        max-height: 750px;
        overflow: hidden auto;

        .balance-inner-information {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 60px;
        }

        .total-div {
            margin-bottom: 60px;
        }

        .upper-div {
            margin-bottom: 15px;
        }

        .margin-top {
            margin-top: 15px;
        }

        h2 {
            font-size: 40px;
            color: @primary-color;
            margin-bottom: 60px;
        }

        .balance-text {
            font-size: 30px;
        }

        .balance-value {
            font-size: 40px;
            color: @primary-color;
        }
    }

    .prod-item-footer {
        position: relative;
        display: flex;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0px 0px 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;
        }
    }
}

#keyboard {
    .keyboard;
    width: inherit;
    max-width: 930px;
    top: inherit;
    bottom: 0;
    position: unset;
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: auto 30px;

        .modal-form-container {
            .title-box {
                height: 50px;

                h2 {
                    font-size: 30px;
                }
            }
        }

        .options-buttons {
            min-height: 200px;
            height: max-content;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-evenly;
            flex-wrap: wrap;
            padding: 5px;
            .button-default {
                width: 150px;
                margin: 0 0 0 0;
            }

            &.has-pager {
                margin: 0 0 5px 0;
                .button-default {
                    margin: 0 0 5px 0 !important;
                }
            }

            &.emailFieldVisible.has-pager {
                margin: 30px 0 !important;
            }
            .message-printer-waiting {
                font-size: 25px;
                padding: 10px 20px;
                text-align: center;
                .small-text {
                    margin-top: 20px;
                    font-size: 18px;
                }
            }
        }

        .message_pager {
            img {
                height: 180px;
                width: 180px;
            }

            p {
                font-size: 16px;
                padding: 5px 20px;
            }

            &.emailFieldVisible {
                display: none !important;
            }
        }

        .form {
            margin: 0px 15px 0px 15px;
            height: 360px;

            .config-item {
                grid-template-columns: 20% 80%;
                margin-bottom: 10px;

                label {
                    font-size: 20px;
                }

                .div-input-android {
                    font-size: 17px;
                    height: 35px;
                    border: 1.5px solid @black;
                    padding: 0 10px;
                    border-radius: 5px;
                }
            }

            #android-keyboard {
                margin: 0;
                .small-screen-keyboard;
            }

            button {
                margin: 10px 0;
            }
        }

        .prod-item-footer {
            height: 60px;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container {
        margin: auto 50px;

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    font-size: 35px;
                }
            }
        }

        .message_pager {
            img {
                height: 280px;
                width: 280px;
            }

            p {
                font-size: 22px;
                padding: 5px 20px;
            }
        }

        .form {
            margin: 0 10px;

            .config-item {
                grid-template-columns: 20% 80%;
                padding: 0px 20px 25px 20px;

                .label-container {
                    label {
                        font-size: 28px;
                    }
                }

                .div-input-android {
                    font-size: 17px;
                    height: 35px;
                    border: 1.5px solid @black;
                    padding: 0 10px;
                    border-radius: 5px;
                }
            }

            .btn-green {
                margin: 20px;
                max-width: -webkit-fill-available;
            }

            #android-keyboard {
                margin: 0;
            }
        }

        .balance-information {
            margin-bottom: 30px;
            max-height: 500px;

            .balance-inner-information {
                margin-bottom: 50px;
            }

            .total-div {
                margin-bottom: 40px;
            }

            .upper-div {
                margin-bottom: 10px;
            }

            h2 {
                font-size: 35px;
                margin-bottom: 40px;
            }

            .balance-text {
                font-size: 25px;
            }

            .balance-value {
                font-size: 30px;
            }
        }

        .prod-item-footer {
            height: 130px;
        }
    }

    #keyboard {
        .keyboard;
        width: inherit;
        position: unset;
        max-width: 760px;
        font-size: 20px;
    }
}

    @media (orientation: landscape) {
        .modal-container {
            margin: auto 50px;

            .modal-form-container {
                .title-box {
                    height: 100px;

                    h2 {
                        font-size: 35px;
                    }
                }
            }

            .message_pager {
                img {
                    height: 280px;
                    width: 280px;
                }

                p {
                    font-size: 22px;
                    padding: 5px 20px;
                }
            }

            .options-buttons {
                /* min-height: 200px; */
                height: max-content;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-evenly;
                flex-wrap: wrap;
                padding: 20px;
                .button-default {
                    width: 45%;
                    margin: 0 0 0 0;
                }

                &.has-pager {
                    margin: 0 0 5px 0;
                    .button-default {
                        margin: 0 0 5px 0 !important;
                    }
                }

                &.emailFieldVisible.has-pager {
                    margin: 30px 0 !important;
                }
                .message-printer-waiting {
                    font-size: 25px;
                    padding: 10px 20px;
                    text-align: center;
                    .small-text {
                        margin-top: 20px;
                        font-size: 18px;
                    }
                }
            }

            .form {
                margin: 0px 15px 0px 15px;

                .config-item {
                    grid-template-columns: 10% 90%;
                    padding: 0px 20px 0px 20px !important;
                    /* margin-bottom: 10px; */

                    label {
                        font-size: 20px;
                    }

                    .div-input-android {
                        font-size: 17px;
                        height: 35px;
                        border: 1.5px solid @black;
                        padding: 0 10px;
                        border-radius: 5px;
                    }
                }

                #android-keyboard {
                    margin: 0;
                    .small-screen-keyboard;
                }

                button {
                    margin: 10px 0;
                }

                .button-default {
                    width: 65%;
                    margin: 10px auto;
                    /* min-width: none; */
                    max-width: none;
                }
            }

            .prod-item-footer {
                height: 60px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/PrintModal.vue